(function (angular) {
	angular.module('bizPartEngage').controller('core.mypage', mypageController);
	angular.module('bizPartEngage').controller('core.mysettings', mysettingsController);
	angular.module('bizPartEngage').controller('core.mysecurity', mysecurityController);
	angular.module('bizPartEngage').controller('core.mycustomsettings', mycustomsettingsController);
	angular.module('bizPartEngage').controller('core.mycolleagues', mycolleaguesController);
	angular.module('bizPartEngage').controller('core.myleaderboards', myleaderboardsController);
	angular.module('bizPartEngage').controller('core.myrelatedusers', myRelatedUsersController);
	angular.module('bizPartEngage').controller('core.mybadges', myBadgesController);
	angular.module('bizPartEngage').controller('core.userprofile', userProfileController);

	mypageController.$inject = [
		'$rootScope',
		'$state',
		'modules.education.service',
		'core.users.service',
		'core.level.serivce',
		'core.event.statistics.service',
		'core.engage.service',
		'modules.certifications.service',
	];
	mysettingsController.$inject = [
		'$rootScope',
		'core.users.service',
		'$mdDialog',
		'$translate',
		'bizMediabankService',
		'bizMediabankUploadService',
		'$mdToast',
		'$q',
		'bizCoreService',
		'bizCore',
		'$filter',
		'$scope',
		'bizPushNotificationService',
	];
	mysecurityController.$inject = ['$rootScope', 'core.users.service', '$mdToast'];
	mycustomsettingsController.$inject = ['$rootScope', 'core.users.service', '$mdToast', '$translate', '$scope'];
	mycolleaguesController.$inject = ['$rootScope', 'core.unit.service'];
	myleaderboardsController.$inject = ['$rootScope', 'core.unit.service', 'core.leaderboard.service'];
	myRelatedUsersController.$inject = ['$rootScope', 'core.users.service', '$mdToast', '$translate', '$stateParams', '$q'];
	userProfileController.$inject = ['$stateParams'];
	myBadgesController.$inject = [];

	function myBadgesController() {
		var vm = this;		
	}

	function userProfileController($stateParams) {
		var vm = this;
		vm.UserId = $stateParams.id ? ~~$stateParams.id : 0;
	}

	function myRelatedUsersController($rootScope, userService, $mdToast, $translate, $stateParams, $q) {
		var vm = this;

		vm.Clean = $stateParams.clean === true;

		vm.AddRelatedUser = AddRelatedUser;
		vm.RemoveRelatedUser = RemoveRelatedUser;
		vm.FilterByRelationType = FilterByRelationType;
		vm.Save = Save;
		vm.GetGenderDisplayNameForRelationType = GetGenderDisplayNameForRelationType;
		vm.IsFormValid = IsFormValid;

		function IsFormValid() {
			if (!vm.MyForm.$valid) return false;

			if (
				$rootScope.MiniSettings.Profile.ShowGender &&
				$rootScope.MiniSettings.Profile.GenderMandatory &&
				vm.RelatedUsers
			) {
				for (var i = 0; i < vm.RelatedUsers.length; i++) {
					if (!vm.RelatedUsers[i].Gender) {
						return false;
					}
				}
			}

			return true;
		}

		function GetGenderDisplayNameForRelationType(genderSystemName, relationSystemName, genderDefaultSystemName) {
			var key = getGenderOverrideKey(genderSystemName, relationSystemName);
			if (vm.GenderOverrides && vm.GenderOverrides[key] && vm.GenderOverrides[key] != key) {
				return vm.GenderOverrides[key];
			}
			return genderDefaultSystemName;
		}

		function FilterByRelationType(relationTypeId) {
			return function (user) {
				if (!user.Relations) return false;

				var relations = user.Relations.GetItemsByValue('RelationTypeId', relationTypeId);
				if (!relations) return false;
				var byParent = relations.GetItemByValue('ParentUserId', $rootScope.LoggedInUser.Id);
				if (byParent !== null) return true;

				return relations.GetItemByValue('ChildUserId', $rootScope.LoggedInUser.Id) !== null;
			};
		}

		function AddRelatedUser(relationTypeId, focus) {
			vm.RelatedUsers.push({
				Relations: [
					{
						RelationTypeId: relationTypeId,
						ParentUserId: $rootScope.LoggedInUser.Id,
					},
				],
				Focus: focus,
			});
		}

		function RemoveRelatedUser(user) {
			var index = vm.RelatedUsers.indexOf(user);
			if (index > -1) {
				vm.RelatedUsers.splice(index, 1);
				vm.MyForm.$setDirty();
			}
		}

		function Save() {
			userService.UpdateRelatedUsers(vm.RelatedUsers).then(
				function (response) {
					SetRelatedUsers(response.data || []);

					vm.MyForm.$setPristine();
					vm.MyForm.$setUntouched();

					vm.HasSaved = true;

					//$mdToast.show($mdToast.simple().content('Successfully saved').position("bottom right"));
					$translate('PROFILE.RELATED_USERS_SAVED').then(function (translation) {
						$mdToast.show($mdToast.simple().content(translation).position('bottom right'));
					});
				},
				function () {
					$mdToast.show($mdToast.simple().content('Error saving').position('bottom right'));
				}
			);
		}

		function getGenderOverrideKey(genderSystemName, relationSystemName) {
			return 'PROFILE.GENDER_OVERRIDES.' + genderSystemName.toUpperCase() + '_' + relationSystemName.toUpperCase();
		}

		function SetRelatedUsers(res) {
			relatedUsers = res;
			for (var i = 0; i < relatedUsers.length; i++) {
				if (relatedUsers[i].Birthdate) {
					relatedUsers[i].Birthdate = moment(new Date(relatedUsers[i].Birthdate)).format('YYYY-MM-DD');
				}
			}
			vm.RelatedUsers = relatedUsers;
		}

		function Init() {
			$q.all([userService.GetRelationTypes(), userService.GetGenders(), userService.GetRelatedUsers()]).then(
				function (result) {
					vm.RelationTypes = result[0].data;
					vm.Genders = result[1].data;
					SetRelatedUsers(result[2].data || []);

					if (
						vm.Clean &&
						vm.RelatedUsers.length === 0 &&
						$rootScope.MiniSettings['Profile'].AutoExpandRelatedUserSystemNamesOnClean.length
					) {
						var autoExpandSystemNames = $rootScope.MiniSettings['Profile'].AutoExpandRelatedUserSystemNamesOnClean;
						for (var i = 0; i < vm.RelationTypes.length; i++) {
							if (autoExpandSystemNames.includes(vm.RelationTypes[i].SystemName)) {
								vm.AddRelatedUser(vm.RelationTypes[i].Id);
							}
						}
					}

					var genderOverrideKeys = [];
					for (var i = 0; i < vm.RelationTypes.length; i++) {
						for (var j = 0; j < vm.Genders.length; j++) {
							genderOverrideKeys.push(
								getGenderOverrideKey(vm.Genders[j].SystemName, vm.RelationTypes[i].SystemName)
							);
						}
					}

					if (genderOverrideKeys.length > 0) {
						$translate(genderOverrideKeys).then(function (translations) {
							vm.GenderOverrides = translations;
						});
					}
				}
			);
		}

		$rootScope.Initialized.then(Init);
	}

	function mycustomsettingsController($rootScope, userService, $mdToast, $translate, $scope) {
		var vm = this;
		vm.MyForm = null;
		vm.Initialized = false;

		vm.Init = Init;
		vm.Save = Save;
		vm.IsFieldRestricted = IsFieldRestricted;
		vm.IsFieldMandatory = IsFieldMandatory;

		function IsFieldMandatory(customField) {
			if (customField.IsMandatory) {
				return true;
			}

			const group = customField.CustomSettings?.GroupName;
			if (!group) return false;

			const groupMandatoryAllOrNone = customField.CustomSettings?.GroupMandatoryAllOrNone;
			if (!groupMandatoryAllOrNone) return false;

			for (var i = 0; i < vm.User.CustomData.length; i++) {
				const customField = vm.User.CustomData[i];
				if (customField.CustomSettings?.GroupName === group && customField.Value) {
					return true;
				}
			}

			return false;
		}

		function IsFieldRestricted(field) {
			if (!vm.RestrictedFields) return false;

			var f = vm.RestrictedFields.find((rf) => rf.FieldType === 2 && rf.Name.toLowerCase() === field.toLowerCase());
			return f !== undefined;
		}

		function Save() {
			if (vm.User.CustomData) {
				for (var i = 0; i < vm.User.CustomData.length; i++) {
					var customField = vm.User.CustomData[i];
					if (customField.SelectedOption) {
						customField.Value = customField.SelectedOption.Id;
					}
				}
			}

			userService.SaveCustomProfileData(vm.User).then(SuccessCallback, HandleError);

			function SuccessCallback(response) {
				vm.MyForm.$setPristine();
				vm.MyForm.$setUntouched();

				$mdToast.show($mdToast.simple().content('Successfully saved').position('bottom right'));
			}

			function HandleError() {
				console.log('error!');
				$mdToast.show($mdToast.simple().content('Error saving profile').position('bottom right'));
			}
		}

		function Init() {
			userService.GetProfile().then(SuccessCallback);
			userService.GetProfileRestrictedFields().then(GetProfileRestrictedFieldsSuccess);

			$translate(['CORE.EXTSETTINGS_DISABLED_TEXT']).then(GetTranslationsCallback);

			function SuccessCallback(response) {
				vm.Initialized = true;
				vm.User = response.data;
				console.log('vm.User', vm.User);

				if (vm.User.CustomData) {
					var currentGroup = null;
					for (var i = 0; i < vm.User.CustomData.length; i++) {
						var customField = vm.User.CustomData[i];
						var group = customField.CustomSettings?.GroupName ?? null;
						if (currentGroup !== group && (i > 0 || group)) {
							//new group on first item only if there is a group
							customField.NewGroup = true;
						}

						currentGroup = group;

						if (customField.CustomSettings?.Options) {
							const selected = customField.CustomSettings.Options.GetItemByValue('Id', customField.Value);
							if (selected) {
								customField.SelectedOption = selected;
							}
						}
					}

					$scope.$watch(
						'vm.User.CustomData',
						function (newValue, oldValue) {
							if (vm.MyForm?.$dirty) {
								return;
							}

							if (newValue && oldValue) {
								for (var i = 0; i < newValue.length; i++) {
									if (newValue[i].SelectedOption !== oldValue[i].SelectedOption) {
										vm.MyForm.$setDirty();
									}
								}
							}
						},
						true
					);
				}
			}

			function GetProfileRestrictedFieldsSuccess(response) {
				vm.RestrictedFields = response.data;
			}

			function GetTranslationsCallback(translations) {
				vm.CustomSettingsDisabledText = '<p>These settings are disabled</p>';

				var t = translations['CORE.EXTSETTINGS_DISABLED_TEXT'].toString();
				if (t !== 'CORE.EXTSETTINGS_DISABLED_TEXT') {
					vm.CustomSettingsDisabledText = t;
				}
			}
		}

		$rootScope.Initialized.then(vm.Init);
	}

	function mysecurityController($rootScope, userService, $mdToast) {
		var vm = this;
		vm.MyForm = null;
		vm.OldPassword;
		vm.NewPassword;
		vm.NewPasswordRepeat;
		vm.ShowPasswords = false;

		vm.Save = Save;
		vm.ToggleShowPassword = ToggleShowPassword;

		function ToggleShowPassword() {
			vm.ShowPasswords = !vm.ShowPasswords;

			document.getElementById('newPassword').setAttribute('type', vm.ShowPasswords ? 'text' : 'password');
			document.getElementById('newPasswordRepeat').setAttribute('type', vm.ShowPasswords ? 'text' : 'password');
		}

		function IsPasswordValidToSave() {
			if (
				vm.OldPassword &&
				vm.OldPassword != '' &&
				vm.NewPassword &&
				vm.NewPassword != '' &&
				vm.NewPassword === vm.NewPasswordRepeat
			)
				return true;

			return false;
		}

		function Save() {
			if (IsPasswordValidToSave() === false) return false;

			userService.UpdateMyPassword(vm.NewPassword, vm.OldPassword).then(UpdateMyPasswordSuccess);

			function UpdateMyPasswordSuccess(response) {
				$mdToast.show($mdToast.simple().content(response.data).position('bottom right'));

				vm.OldPassword = undefined;
				vm.NewPassword = undefined;
				vm.NewPasswordRepeat = undefined;

				vm.MyForm.$setPristine();
				vm.MyForm.$setUntouched();

				return true;
			}
		}
	}

	function mypageController(
		$rootScope,
		$state,
		educationService,
		userService,
		levelService,
		eventStatisticsService,
		engageService,
		certificationsService
	) {
		var vm = this;
		vm.PageMax = 20;
		vm.UserStats = undefined;
		vm.AuthToken = getBizPartAuthToken();
		vm.Mascot = mascot;

		vm.EducationCount = -1;
		vm.BlogCount = -1;
		vm.VideoCount = -1;
		vm.ScormCount = -1;
		vm.QuizCount = -1;
		vm.TotalEducationCount = -1;

		vm.Notifications = [];
		vm.NotificationDefaultLimit = 4;
		vm.NotificationMaxLimit = 15;
		vm.NotificationDisplayLimit = 4;
		vm.NotificationsPage = 1;
		vm.ActivityLog = [];
		vm.ActivityLogPage = 1;
		vm.GainMoreExperience = [];
		vm.GainMoreExperiencePage = 1;
		vm.LastGainedExperience = [];
		vm.LastGainedExperiencePage = 1;
		vm.CertificationCount = 0;
		vm.CompletedEducationCount = 0;

		vm.GetCompletedCount = GetCompletedCount;
		vm.GetLoggedInUserNotifications = GetLoggedInUserNotifications;
		vm.GetLoggedInUserExperiencePointHistory = GetLoggedInUserExperiencePointHistory;
		vm.GetAllEventStatisticsForUser = GetAllEventStatisticsForUser;
		vm.GetSuggestions = GetSuggestions;
		vm.GoToSuggestion = GoToSuggestion;
		vm.GetSuggestionIcon = GetSuggestionIcon;
		vm.ShowMoreNotifications = ShowMoreNotifications;
		vm.ShowCertificates = ShowCertificates;
		vm.GetUserLogStats = GetUserLogStats;
		vm.GetStatCount = GetStatCount;
		vm.Initialize = Initialize;
		vm.GoToItem = GoToItem;

		function ShowMoreNotifications() {
			vm.NotificationDisplayLimit = vm.NotificationMaxLimit;
		}

		function GoToItem(item) {
			//The types that only should be clickable for the users own items
			if (
				item.Settings &&
				~~item.Settings.ObjectOwnerUserId > 0 &&
				item.Settings.ObjectOwnerUserId === $rootScope.LoggedInUser.Id
			) {
				switch (item.ObjectType) {
					case 'GOAL':
						$state.go('base.modules.goals.onegoal', { id: ~~item.ObjectId > 0 ? ~~item.ObjectId : 'new' });
						break;
					case 'TODO':
						$state.go('base.modules.goals.onetask', { id: ~~item.ObjectId > 0 ? ~~item.ObjectId : 'new' });
						break;
					case 'ACTIVITY':
						$state.go('base.modules.goals.activity', { id: ~~item.ObjectId > 0 ? ~~item.ObjectId : 'new' });
						break;
				}
			}

			//The types that should be clickable for any user (as long as they have access, which should be fixed on backend)
			switch (item.ObjectType) {
				case 'HTML5':
					$state.go('base.modules.html5education', { id: item.ObjectId });
					break;
				case 'MediabankFile':
					$state.go('base.modules.mediafile', { id: item.ObjectId });
					break;
				case 'Blog':
					$state.go('base.modules.blogtitle', { title: item.ObjectId });
					break;
				case 'SCORM':
					$state.go('base.modules.scormeducation', { id: item.ObjectId });
					//location.href = siteRootPath + 'SCORM/' + item.ObjectId;
					break;

					
			}
		}

		function GetStatCount(types) {
			var count = -1;
			if (types && vm.UserStats) {
				//We handle multiple types...
				if (types.length > 1) {
					for (var i = 0; i < types.length; i++) {
						for (var y = 0; y < vm.UserStats.EngageObjectLogs.length; y++) {
							if (
								vm.UserStats.EngageObjectLogs[y].EngageObjectType === types[i] &&
								vm.UserStats.EngageObjectLogs[y].Passed === true
							) {
								count++;
							}
						}
					}
				} else {
					for (var i = 0; i < vm.UserStats.EngageObjectLogs.length; i++) {
						if (
							vm.UserStats.EngageObjectLogs[i].EngageObjectType === types &&
							vm.UserStats.EngageObjectLogs[i].Passed === true
						) {
							count++;
						}
					}
				}
			}

			return count;
		}

		function GetUserLogStats() {
			userService.GetUserLogStats().then(function (response) {
				vm.UserStats = response.data;

				var eduCount = 0;
				var blogCount = 0;
				var videoCount = 0;
				var scormCount = 0;
				var quizCount = 0;
				for (var i = 0; i < vm.UserStats.EngageObjectLogs.length; i++) {
					if (vm.UserStats.EngageObjectLogs[i].Passed === true) {
						switch (vm.UserStats.EngageObjectLogs[i].EngageObjectType) {
							case 1:
								eduCount++;
								break;
							case 2:
								blogCount++;
								break;
							case 3:
								videoCount++;
								break;
							case 4:
								scormCount++;
								break;
							case 5:
								quizCount++;
								break;
						}
					}
				}

				vm.EducationCount = eduCount;
				vm.BlogCount = blogCount;
				vm.VideoCount = videoCount;
				vm.ScormCount = scormCount;
				vm.QuizCount = quizCount;
				vm.TotalEducationCount = eduCount + scormCount;

				console.log('count done');
			});
		}

		function ShowCertificates() {
			$mdDialog.show({
				templateUrl: siteRootPath + 'Frontend/Core/Views/mypagecertificates.html',
				controllerAs: 'vm',
				controller: certificateController,
				bindToController: true,
			});

			certificateController.$inject = ['$mdDialog'];

			function certificateController($mdDialog) {
				var vm = this;

				vm.GetCertificates = GetCertificates;

				function GetCertificates() {}
			}
		}

		function GetCompletedCount() {
			educationService.GetCompletedCount().then(GetCompletedCountSuccess);

			function GetCompletedCountSuccess(response) {
				vm.CompletedEducationCount = response.data.Education;
				vm.CompletedEducationCount += response.data.CertificationEducation;

				vm.CertificationCount = response.data.Certification;
			}
		}

		function GetLoggedInUserNotifications(page) {
			userService.GetLoggedInUserNotifications(vm.PageMax, page).then(GetLoggedInUserNotificationsSuccess);

			function GetLoggedInUserNotificationsSuccess(response) {
				vm.Notifications = response.data;
			}
		}

		function GetLoggedInUserExperiencePointHistory(page) {
			levelService
				.GetLoggedInUserExperiencePointHistory(vm.PageMax, page)
				.then(GetLoggedInUserExperiencePointHistorySuccess);

			function GetLoggedInUserExperiencePointHistorySuccess(response) {
				vm.LastGainedExperience = response.data;
			}
		}

		function GetAllEventStatisticsForUser(page) {
			eventStatisticsService.GetAllEventStatisticsForUser(page, vm.PageMax).then(GetAllEventStatisticsForUserSuccess);

			function GetAllEventStatisticsForUserSuccess(response) {
				vm.ActivityLog = response.data;
			}
		}

		function GetSuggestions(page) {
			engageService.GetSuggestions(page, vm.PageMax).then(GetSuggestionsSuccess);

			function GetSuggestionsSuccess(response) {
				vm.GainMoreExperience = response.data;
			}
		}

		function GoToSuggestion(item) {
			switch (item.ControlType) {
				case 'HTML5EDUCATION':
					$state.go('base.modules.html5education', { id: item.Value.Id });
					break;
				case 'MISSION':
					$state.go('base.modules.missionsview', { id: item.Value.Id });
					break;
				case 'SCORM':
					$state.go('base.modules.scormeducation', { id: item.Value.Id });
					break;
			}
		}

		function GetSuggestionIcon(item) {
			switch (item.ControlType) {
				case 'HTML5EDUCATION':
					return 'fa-graduation-cap';
				case 'MISSION':
					return 'fa-star';
				case 'SCORM':
					return 'fa-graduation-cap';
			}
		}

		function GetCertificationsForUser() {
			certificationsService.GetCertificationsForUser().then(function (response) {
				vm.UserCerts = response.data;
			});
		}

		function Initialize() {
			vm.GetCompletedCount();
			vm.GetLoggedInUserNotifications(vm.NotificationsPage);
			vm.GetAllEventStatisticsForUser(vm.ActivityLogPage);
			vm.GetSuggestions(vm.GainMoreExperiencePage);

			vm.GetUserLogStats();
			GetCertificationsForUser();

			if (IsPortalSettingTrue('IsLevelSystemEnabled') && $rootScope.ShowXP) {
				vm.GetLoggedInUserExperiencePointHistory(vm.LastGainedExperiencePage);
			}
		}

		vm.Initialize();
	}

	function mysettingsController(
		$rootScope,
		userService,
		$mdDialog,
		$translate,
		bizMediabankService,
		bizMediabankUploadService,
		$mdToast,
		$q,
		bizCoreService,
		bizCoreProvider,
		$filter,
		$scope,
		bizPushNotificationService
	) {
		var vm = this;
		vm.MyForm = null;
		vm.Initialized = false;
		vm.GendersInitialized = $q.defer();
		vm.CountriesInitialized = $q.defer();
		vm.UnitTypesInitialized = $q.defer();
		vm.UserUnitsInitialized = $q.defer();

		vm.GetUser = GetUser;
		vm.UpdateCustomFieldValue = UpdateCustomFieldValue;
		vm.GetCustomFieldValue = GetCustomFieldValue;

		vm.AllowSms = false;
		vm.PortalCustomerName = portalCustomerName;
		vm.NotificationSettings = notificationSettings;

		vm.SaveMyDetails = SaveMyDetails;
		vm.Unregister = Unregister;
		vm.AskToUnregister = AskToUnregister;
		vm.UpdateAllowSMSForLoggedInUser = UpdateAllowSMSForLoggedInUser;
		vm.GetLoggedInUserSetting = GetLoggedInUserSetting;
		vm.GetLoggedInUserSettingAsBoolean = GetLoggedInUserSettingAsBoolean;
		vm.SetFile = SetFile;
		vm.SetTempFile = SetTempFile;
		vm.GetProfileImageUrl = GetProfileImageUrl;
		vm.FavoriteTagFilter = FavoriteTagFilter;
		vm.SetSelectedUserType = SetSelectedUserType;
		vm.GetProfileRestrictedFields = GetProfileRestrictedFields;
		vm.IsFieldRestricted = IsFieldRestricted;
		vm.SetGender = SetGender;
		vm.IsFormValid = IsFormValid;
		vm.PushNotificationState = { status: 'loading' };
		vm.PushNotificationBusy = false;
		vm.EnablePushNotifications = EnablePushNotifications;
		vm.DisablePushNotifications = DisablePushNotifications;

		vm.Initialize = Initialize;

		function EnablePushNotifications() {
			UpdatePushNotificationState(bizPushNotificationService.Enable());
		}

		function DisablePushNotifications() {
			UpdatePushNotificationState(bizPushNotificationService.Disable());
		}

		function UpdatePushNotificationState(statePromise) {
			vm.PushNotificationBusy = true;
			statePromise.then(function (state) {
				vm.PushNotificationState = state;
			}).finally(function () {
				vm.PushNotificationBusy = false;
			});
		}

		function IsFormValid() {
			if (!vm.MyForm.$valid) return false;

			if (
				$rootScope.MiniSettings.Profile.ShowGender &&
				$rootScope.MiniSettings.Profile.GenderMandatory &&
				!vm.User.Gender
			) {
				return false;
			}

			return true;
		}

		function GetProfileImageUrl() {
			if (!vm.User) return $filter('siteroot')('Images/Common/no_user_photo.png');

			return vm.TempFile
				? $filter('ngfDataUrl')(vm.TempFile)
				: $filter('siteroot')(vm.User.Photo ? vm.User.Photo : 'Images/Common/no_user_photo.png');
		}

		function IsFieldRestricted(field) {
			if (!vm.RestrictedFields) return false;

			var f = vm.RestrictedFields.find((rf) => rf.FieldType === 1 && rf.Name.toLowerCase() === field.toLowerCase());
			return f !== undefined;
		}

		function GetProfileRestrictedFields() {
			userService.GetProfileRestrictedFields().then(GetProfileRestrictedFieldsSuccess);

			function GetProfileRestrictedFieldsSuccess(response) {
				vm.RestrictedFields = response.data;
			}
		}

		function GetUser() {
			userService.GetProfile().then(GetLoggedInUserSuccess); //GetLoggedInUserFromDB

			function GetLoggedInUserSuccess(response) {
				vm.Initialized = true;

				var user = response.data;
				if (user.Birthdate) {
					user.Birthdate = moment(new Date(user.Birthdate)).format('YYYY-MM-DD');
				}
				vm.User = user;

				// Initialize CustomFile property for each custom field with DataType == 10
				if (vm.User.CustomFields) {
					for (var i = 0; i < vm.User.CustomFields.length; i++) {
						var cf = vm.User.CustomFields[i];
						if (cf.DataType === 10) {
							// Initialize the CustomFile object for file-type custom fields
							let mbfParts = (cf.Value.Value || '').toString().split('|');
							if (mbfParts.length === 3) {
								cf.CustomFile = {
									Id: parseInt(mbfParts[0], 10),
									Thumbnail: mbfParts[1],
									FileUrl: mbfParts[2],
								};
							} else {
								cf.CustomFile = {
									FileUrl: cf.Value.Value || '',
								};
							}

							// Set up a watcher for this specific custom field using closure
							(function (customField, fieldIndex) {
								$scope.$watch(
									'vm.User.CustomFields[' + fieldIndex + '].CustomFile.FileUrl',
									function (newValue, oldValue) {
										if (newValue !== oldValue) {
											let newFile = vm.User.CustomFields[fieldIndex].CustomFile;
											let mbfParts = [];
											mbfParts.push(newFile.Id > 0 ? newFile.Id : -1);
											mbfParts.push(newFile.Thumbnail ? newFile.Thumbnail : '');
											mbfParts.push(newFile.FileUrl ? newFile.FileUrl : '');
											mbfParts.join('|');

											customField.Value.Value = mbfParts.join('|');
											console.log('Custom field ' + customField.Name + ' updated:', mbfParts);
											if (vm.MyForm) vm.MyForm.$setDirty();
										}
									}
								);
							})(cf, i);
						}
					}
				}

				vm.GetCustomFieldValue();
				vm.SetSelectedUserType();
				vm.SetGender();
				SetCountry();
				SetUnits();

				vm.Now = new Date();

				vm.HadMiddleNameOnLastFetch = vm.User.MiddleName && vm.User.MiddleName.length > 0;
			}
		}

		function SetUnits() {
			vm.UnitTypesInitialized.promise.then(function () {
				//todo: support for multiple units of the same type, because that might be the case, right?
				for (var i = 0; i < vm.User.Units.length; i++) {
					var ut = vm.AllowedUnitTypesToEdit.GetItemByValue('Id', vm.User.Units[i].UnitTypeId);
					if (ut) {
						var unit = ut.Units.GetItemByValue('Id', vm.User.Units[i].Id);
						if (unit) {
							ut.SelectedUnit = unit;
						}
					}
				}

				console.log('unittypes init user', vm.User);

				vm.UserUnitsInitialized.resolve('');
			});
		}

		function SetCountry() {
			vm.CountriesInitialized.promise.then(function () {
				if (vm.User.CountryId > 0) {
					var userCountry = vm.Countries.filter((c) => c.Id === vm.User.CountryId);
					if (userCountry.length === 1) {
						vm.SelectedCountry = userCountry[0];
					} else {
						console.log('more than one country matched? something is wrong...');
					}
				}
			});
		}

		function SetGender() {
			vm.GendersInitialized.promise.then(function () {
				if ($rootScope.MiniSettings['Profile'].CustomGenderFilterFn) {
					vm.Genders = $rootScope.MiniSettings['Profile'].CustomGenderFilterFn(vm.Genders, vm.User);
				}

				if (vm.User.Gender) {
					var userGender = vm.Genders.filter((g) => g.SystemName.toLowerCase() == vm.User.Gender.toLowerCase());
					if (userGender.length === 1) {
						vm.User.Gender = userGender[0].SystemName; //in case there is a case difference
					} else if (userGender.length === 0) {
						vm.Genders.push({
							SystemName: vm.User.Gender,
							DisplayName: vm.User.Gender,
						});
					} else {
						console.log('more than one gender matched? something is wrong...');
					}
				}
			});
		}

		function GetCustomFieldValue() {
			userService.GetCustomFieldValue(1, vm.User.Id).then(GetCustomFieldValueSuccess);

			function GetCustomFieldValueSuccess(response) {
				if (response.data) vm.CompanyNumber = response.data.Value ? response.data.Value : undefined;
			}
		}

		function UpdateCustomFieldValue() {
			userService.UpdateCustomFieldValue(1, vm.User.Id, vm.CompanyNumber).then(UpdateCustomFieldValueSuccess);

			function UpdateCustomFieldValueSuccess(response) {}
		}

		function SetTempFile(files) {
			if (!files.length) return;

			vm.TempFile = files[0];
			console.log(vm.TempFile);

			vm.MyForm.$setDirty();
		}

		function SetFile(file) {
			if (file.length > 0) {
				vm.File = file[0];

				var settings = {
					FileType: bizMediabankService.FileTypes.Image,
					FileLocation: bizMediabankService.UploadLocations.UserProfile,
					FilePattern: '',
					IsPrivate: true,
					IsInvisible: true,
					IsPrivateControlHidden: true,
					IsInvisibleControlHidden: true,
					IsUser: true,
				};

				var promise = bizMediabankUploadService.UploadFile(
					vm.File,
					vm.File.name,
					'',
					bizMediabankService.UploadLocations.UserProfile,
					true,
					true,
					settings,
					[],
					[]
				);
				promise.then(UploadFileSuccessCallback);

				return promise;

				function UploadFileSuccessCallback(response) {
					if (response) {
						var status = response.data;
						vm.File = status;
						vm.User.Photo = vm.File.FileUrl;
						$rootScope.LoggedInUser.Photo = vm.File.FileUrl;
						vm.TempFile = undefined;
						userService.SaveBasicProfile(vm.User);
					}
				}
			}
		}

		function SaveMyDetails(showToast) {
			if (vm.TempFile) vm.SetFile([vm.TempFile]).then(SuccessCallback);
			else {
				vm.User.UserTypeId = vm.SelectedUserType && vm.SelectedUserType.Id > 0 ? vm.SelectedUserType.Id : -1;
				vm.User.CountryId = vm.SelectedCountry && vm.SelectedCountry.Id > 0 ? vm.SelectedCountry.Id : -1;

				//todo: support for multiple units of the same type, because that might be the case, right?
				if (vm.AllowedUnitTypesToEdit) {
					for (var i = 0; i < vm.AllowedUnitTypesToEdit.length; i++) {
						var ut = vm.AllowedUnitTypesToEdit[i];
						var currentUserUnitsForType = vm.User.Units.filter((u) => u.UnitTypeId === ut.Id);
						if (currentUserUnitsForType.length > 1) {
							console.error('Multiple units of the same type not supported yet');
							continue; //no support for multiple units of the same type yet
						}

						var currentUserUnit = currentUserUnitsForType.length === 1 ? currentUserUnitsForType[0] : null;

						var removeCurrentUnit =
							currentUserUnit && (!ut.SelectedUnit || ut.SelectedUnit.Id !== currentUserUnit.Id);
						var addNewUnit = ut.SelectedUnit && (!currentUserUnit || ut.SelectedUnit.Id !== currentUserUnit.Id);

						if (removeCurrentUnit) {
							vm.User.Units = vm.User.Units.filter((u) => u.Id !== currentUserUnit.Id);
						}

						if (addNewUnit) {
							vm.User.Units.push(ut.SelectedUnit);
						}
					}
				}

				userService.SaveBasicProfile(vm.User).then(SuccessCallback);
			}

			vm.UpdateAllowSMSForLoggedInUser();

			if (vm.CompanyNumber && vm.CompanyNumber != '') vm.UpdateCustomFieldValue();

			function SuccessCallback(response) {
				$rootScope.LoggedInUser = angular.copy(vm.User);

				vm.IsEditMode = false;

				vm.MyForm.$setPristine();
				vm.MyForm.$setUntouched();

				if (showToast) {
					$translate('CORE.DETAILSUPDATED').then(function (translation) {
						$mdToast.show($mdToast.simple().content(translation).position('bottom right'));
					});
				}

				$rootScope.$broadcast('USER_UPDATED');
			}
		}

		function Unregister() {
			userService.DeleteMe().then(DeleteMeSuccess);

			function DeleteMeSuccess() {
				window.location.href = siteRootPath;
			}
		}

		function AskToUnregister() {
			$translate('CORE.ASKTOUNREGISTER').then(function (translation) {
				$mdDialog
					.show({
						templateUrl: bizCoreProvider.getView('base.dialog', 'FrontEnd/Views/Dialogs/dialog-primary.html'),
						controller: profileDialogController,
						controllerAs: 'vm',
						locals: {
							Text: translation,
							IsSureCheck: true,
						},
						bindToController: true,
					})
					.then(function (response) {
						if (response) {
							vm.Unregister();
						}
					});
			});
		}

		function UpdateAllowSMSForLoggedInUser() {
			userService
				.UpdateAllowSMSForLoggedInUser(vm.AllowSms)
				.then(UpdateAllowSMSForLoggedInUserSuccess)
				.catch(UpdateAllowSMSForLoggedInUserError);

			function UpdateAllowSMSForLoggedInUserSuccess(response) {}

			function UpdateAllowSMSForLoggedInUserError(err) {
				vm.AllowSms = !vm.AllowSms;

				$translate('CORE.ERROR.SOMETHING').then(function (translation) {
					$mdDialog
						.show({
							templateUrl: bizCoreProvider.getView('base.dialog', 'FrontEnd/Views/Dialogs/dialog-primary.html'),
							controller: profileDialogController,
							controllerAs: 'vm',
							locals: {
								Text: translation,
							},
							bindToController: true,
						})
						.then(function (response) {});
				});
			}
		}

		function GetLoggedInUserSetting(key, callback) {
			userService.GetLoggedInUserSetting(key).then(callback);
		}

		function GetLoggedInUserSettingAsBoolean(key, callback) {
			userService.GetLoggedInUserSettingAsBoolean(key).then(callback);
		}

		function FavoriteTagFilter(tag) {
			return vm.ShowMoreFavorites || tag.Favorite === undefined || tag.Favorite;
		}

		function SetSelectedUserType() {
			if (vm.UserTypes && vm.User) {
				vm.SelectedUserType = vm.UserTypes.GetItemByValue('Id', vm.User.UserTypeId);
			}
		}

		function Initialize() {
			UpdatePushNotificationState(bizPushNotificationService.GetStatus());
			userService.GetGenders().then(GetGendersCallback);

			vm.GetProfileRestrictedFields();
			vm.GetUser();

			vm.GetLoggedInUserSettingAsBoolean('blnAllowSMS', function (response) {
				vm.AllowSms = response.data;
			});

			bizCoreService.GetAllTags($rootScope.LoggedInUser.CurrentCultureId).then(GetTagsCallback);
			userService.GetUserTypes().then(GetUserTypesCallback);
			bizCoreService.GetAllActiveCountries().then(GetAllActiveCountriesCallback);
			userService.GetProfileAllowedUnitsToEdit().then(GetProfileAllowedUnitsToEditCallback);

			function GetTagsCallback(response) {
				vm.Tags = response.data;
			}

			function GetUserTypesCallback(response) {
				vm.UserTypes = response.data;
				vm.UserTypes = $filter('orderBy')(vm.UserTypes, 'Name');
				vm.SetSelectedUserType();
			}

			function GetAllActiveCountriesCallback(response) {
				vm.Countries = response.data;
				vm.CountriesInitialized.resolve('');
			}

			function GetGendersCallback(response) {
				var genders = BizPartCoreHelpers.getResponseValue(response);
				if ($rootScope.MiniSettings['Profile'].CustomGenderFilterFn) {
					vm.Genders = $rootScope.MiniSettings['Profile'].CustomGenderFilterFn(genders);
				} else {
					vm.Genders = genders;
				}

				vm.GendersInitialized.resolve('');
			}

			function GetProfileAllowedUnitsToEditCallback(response) {
				vm.AllowedUnitsToEdit = response.data;
				vm.AllowedUnitTypesToEdit = [];
				for (var i = 0; i < vm.AllowedUnitsToEdit.length; i++) {
					var ut = vm.AllowedUnitTypesToEdit.GetItemByValue('Id', vm.AllowedUnitsToEdit[i].UnitTypeId);
					if (!ut) {
						ut = {
							Id: vm.AllowedUnitsToEdit[i].UnitTypeId,
							Name: vm.AllowedUnitsToEdit[i].UnitTypeName,
							Units: [],
						};
						vm.AllowedUnitTypesToEdit.push(ut);
					}
					ut.Units.push(vm.AllowedUnitsToEdit[i]);
				}
				vm.UnitTypesInitialized.resolve('');
			}

			$scope.$watch(
				'vm.SelectedCountry',
				function (newValue, oldValue) {
					if (vm.MyForm?.$dirty) {
						return;
					}

					if (oldValue && newValue != oldValue) {
						vm.MyForm.$setDirty();
					}
				},
				true
			);

			vm.UserUnitsInitialized.promise.then(function () {
				$scope.$watch(
					'vm.AllowedUnitTypesToEdit',
					function (newValue, oldValue) {
						if (vm.MyForm?.$dirty || !newValue || !oldValue) {
							return;
						}

						for (var i = 0; i < newValue.length; i++) {
							if (newValue[i].SelectedUnit?.Id !== oldValue[i].SelectedUnit?.Id) {
								console.log('unit changed, new', newValue[i].SelectedUnit?.Id);
								console.log('unit changed, old', oldValue[i].SelectedUnit?.Id);
								vm.MyForm.$setDirty();
							}
						}
					},
					true
				);
			});
		}

		profileDialogController.$inject = ['$mdDialog'];

		function profileDialogController($mdDialog) {
			var vm = this;

			vm.Close = Close;
			vm.Ok = Ok;

			function Close() {
				$mdDialog.cancel();
			}

			function Ok() {
				$mdDialog.hide(true);
			}
		}

		$rootScope.Initialized.then(vm.Initialize);
	}

	function mycolleaguesController($rootScope, unitService) {
		var vm = this;
		vm.MyUnit = {};
		vm.UnitUsers = [];
		vm.Units = [];
		vm.ShowSpecificUnit = false;
		vm.SelectedUser = undefined;

		vm.GetUsersInUnit = GetUsersInUnit;
		vm.Initialize = Initialize;
		vm.GetCustomFieldValue = GetCustomFieldValue;

		function GetCustomFieldValue(u, systemName) {
			const cf = u.CustomFields?.find((field) => field.SystemName === systemName);

			return cf?.Value?.Value || '';
		}

		function InitializeUnit() {
			if ($rootScope.LoggedInUser.Units.length == 1) {
				vm.MyUnit = $rootScope.LoggedInUser.Units[0];				

				if (vm.HideParentUnit) {
					vm.ShowSpecificUnit = false;
					vm.Tab = 1;
					//"local unit" should be default
					GetUsersInUnit(vm.MyUnit.Id);
				} else {
					if (~~vm.MyUnit.ParentId > 0) {
						GetUnitsByParent(~~vm.MyUnit.ParentId);
					} else {
						GetUsersInUnit(vm.MyUnit.Id);
					}
				}
			} else {
				//Handle multiple units...
			}
		}

		function GetUsersInUnit(unitId) {
			vm.UnitUsers = [];
			unitService.GetUsersInUnit(unitId).then(GetUsersInUnitSuccess);

			function GetUsersInUnitSuccess(response) {
				vm.UnitUsers = response.data;
			}
		}

		function GetUnitsByParent(parentId) {
			unitService.GetUnitsByParent(parentId).then(GetUnitsByParentSuccess);

			function GetUnitsByParentSuccess(response) {
				vm.Units = response.data;
			}
		}

		function Initialize() {
			InitializeUnit();
		}

		$rootScope.Initialized.then(vm.Initialize);
	}

	function myleaderboardsController($rootScope, unitService, leaderboardService) {
		var vm = this;
		vm.MyUnit = {};
		vm.MainUnitLeaderboard = [];
		vm.MainUnitLeaderboardMonth = [];
		vm.MainUnitLeaderboardYear = [];
		vm.UnitLeaderboard = [];
		vm.UnitLeaderboardMonth = [];
		vm.UnitLeaderboardYear = [];
		vm.Limit = 5;

		vm.Initialize = Initialize;
		vm.InitializeUnit = InitializeUnit;
		vm.GetMainUnitLeaderboard = GetMainUnitLeaderboard;
		vm.GetMainUnitLeaderboardBetweenDates = GetMainUnitLeaderboardBetweenDates;
		vm.GetUnitLeaderboard = GetUnitLeaderboard;
		vm.GetUnitLeaderboardBetweenDates = GetUnitLeaderboardBetweenDates;

		function InitializeUnit() {
			if ($rootScope.LoggedInUser.Units.length <= 1) {
				vm.MyUnit = $rootScope.LoggedInUser.Units[0];
			} else {
				//Handle multiple units...
			}
		}

		function GetMainUnitLeaderboard() {
			leaderboardService.GetMainUnitLeaderboard(vm.Limit).then(GetMainUnitLeaderboardSuccess);

			function GetMainUnitLeaderboardSuccess(response) {
				vm.MainUnitLeaderboard = response.data;

				console.log('vm.MainUnitLeaderboard', vm.MainUnitLeaderboard);
			}
		}

		function GetMainUnitLeaderboardBetweenDates(startTime, endTime, callback) {
			leaderboardService.GetMainUnitLeaderboardBetweenDates(vm.Limit, startTime, endTime).then(callback);
		}

		function GetUnitLeaderboard() {
			leaderboardService.GetUnitLeaderboard(vm.Limit).then(GetUnitLeaderboardSuccess);

			function GetUnitLeaderboardSuccess(response) {
				vm.UnitLeaderboard = response.data;
			}
		}

		function GetUnitLeaderboardBetweenDates(startTime, endTime, callback) {
			leaderboardService.GetUnitLeaderboardBetweenDates(vm.Limit, startTime, endTime).then(callback);
		}

		function Initialize() {
			InitializeUnit();

			if (vm.MyUnit && vm.MyUnit.ParentId) {
				vm.GetMainUnitLeaderboard();
				vm.GetMainUnitLeaderboardBetweenDates(
					moment().startOf('month').format('YYYY-MM-DD hh:mm'),
					moment().endOf('month').format('YYYY-MM-DD hh:mm'),
					MonthLeaderboardCallback
				);
				vm.GetMainUnitLeaderboardBetweenDates(
					moment().startOf('year').format('YYYY-MM-DD hh:mm'),
					moment().endOf('year').format('YYYY-MM-DD hh:mm'),
					YearLeaderboardCallback
				);
			}

			if (vm.MyUnit) {
				vm.GetUnitLeaderboard();
				vm.GetUnitLeaderboardBetweenDates(
					moment().startOf('month').format('YYYY-MM-DD hh:mm'),
					moment().endOf('month').format('YYYY-MM-DD hh:mm'),
					MonthUnitLeaderboardCallback
				);
				vm.GetUnitLeaderboardBetweenDates(
					moment().startOf('year').format('YYYY-MM-DD hh:mm'),
					moment().endOf('year').format('YYYY-MM-DD hh:mm'),
					YearUnitLeaderboardCallback
				);
			}

			if (!vm.MyUnit) {
				leaderboardService.GetCountryLeaderboard(vm.Limit).then(function (response) {
					vm.CountryLeaderboard = response.data;
				});

				leaderboardService
					.GetCountryLeaderboard(
						vm.Limit,
						moment().startOf('month').format('YYYY-MM-DD hh:mm'),
						moment().endOf('month').format('YYYY-MM-DD hh:mm')
					)
					.then(function (response) {
						vm.CountryLeaderboardMonth = response.data;
					});

				leaderboardService
					.GetCountryLeaderboard(
						vm.Limit,
						moment().startOf('year').format('YYYY-MM-DD hh:mm'),
						moment().endOf('year').format('YYYY-MM-DD hh:mm')
					)
					.then(function (response) {
						vm.CountryLeaderboardYear = response.data;
					});
			}
		}

		function MonthLeaderboardCallback(response) {
			vm.MainUnitLeaderboardMonth = response.data;
		}

		function YearLeaderboardCallback(response) {
			vm.MainUnitLeaderboardYear = response.data;
		}

		function MonthUnitLeaderboardCallback(response) {
			vm.UnitLeaderboardMonth = response.data;
		}

		function YearUnitLeaderboardCallback(response) {
			vm.UnitLeaderboardYear = response.data;
		}

		$rootScope.Initialized.then(vm.Initialize);
	}
})(window.angular);
